// extracted by mini-css-extract-plugin
module.exports = {"main__title":"title_main__title__1R0zm","title":"title_title__2jzCV"};